import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useScroll } from "../../scroll/ScrollProvider";

/**
 * DataCenterHall — realistic aisle of server racks with LED strips.
 * Used for Section 7 (Power / infrastructure narrative beat).
 */
export function DataCenterHall() {
  const root = useRef<THREE.Group>(null);
  const { section, sectionProgress } = useScroll();

  const racks = useMemo(() => {
    const out: { x: number; z: number; hue: number }[] = [];
    for (let row = 0; row < 2; row++) {
      for (let i = 0; i < 9; i++) {
        out.push({
          x: row === 0 ? -1.35 : 1.35,
          z: -i * 0.95,
          hue: 0.52 + ((i + row) % 4) * 0.03,
        });
      }
    }
    return out;
  }, []);

  useFrame((_state, delta) => {
    const active = section < 7 ? 0 : section === 7 ? sectionProgress : 1;
    if (!root.current) return;
    root.current.position.z = active * 0.35;
    root.current.rotation.y = -0.03 + active * 0.08;
    root.current.position.y = -0.35 + Math.sin(performance.now() * 0.00035) * 0.02;
    root.current.children.forEach((c, i) => {
      if (i % 5 !== 0) return;
      c.rotation.y += delta * 0.01;
    });
  });

  return (
    <group ref={root}>
      {racks.map((r, i) => (
        <group key={i} position={[r.x, 0, r.z]}>
          <mesh castShadow>
            <boxGeometry args={[0.62, 1.85, 0.68]} />
            <meshStandardMaterial color="#0f1218" metalness={0.88} roughness={0.34} />
          </mesh>
          <mesh position={[0, 0.72, 0.345]}>
            <boxGeometry args={[0.46, 0.08, 0.01]} />
            <meshBasicMaterial color={new THREE.Color().setHSL(r.hue, 0.85, 0.62)} toneMapped={false} />
          </mesh>
          <mesh position={[0, 0.38, 0.345]}>
            <boxGeometry args={[0.46, 0.08, 0.01]} />
            <meshBasicMaterial color="#7ea2ff" toneMapped={false} />
          </mesh>
          <mesh position={[0, 0.04, 0.345]}>
            <boxGeometry args={[0.46, 0.08, 0.01]} />
            <meshBasicMaterial color="#78d6ff" toneMapped={false} />
          </mesh>
        </group>
      ))}

      <pointLight position={[0, 1.6, -2.8]} intensity={1.25} color="#89b5ff" distance={12} decay={2} />
    </group>
  );
}
